"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolUniverse = void 0;
class SymbolUniverse {
    constructor(symbols) {
        this.symbols = symbols;
    }
}
exports.SymbolUniverse = SymbolUniverse;
//# sourceMappingURL=SymbolUniverse.js.map